import { render, staticRenderFns } from "./LocalesSelect.vue?vue&type=template&id=7a16edbe"
import script from "./LocalesSelect.vue?vue&type=script&lang=js"
export * from "./LocalesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports